var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLinkedIn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93789 13.1247H0.216797V4.36201H2.93789V13.1247ZM1.57588 3.1667C0.705762 3.1667 0 2.446 0 1.57588C6.22793e-09 1.15793 0.16603 0.757099 0.461564 0.461564C0.757099 0.16603 1.15793 0 1.57588 0C1.99383 0 2.39466 0.16603 2.69019 0.461564C2.98573 0.757099 3.15176 1.15793 3.15176 1.57588C3.15176 2.446 2.4457 3.1667 1.57588 3.1667ZM13.1221 13.1247H10.4068V8.85909C10.4068 7.84248 10.3863 6.53877 8.99209 6.53877C7.57734 6.53877 7.36055 7.64326 7.36055 8.78584V13.1247H4.64238V4.36201H7.25215V5.55733H7.29023C7.65352 4.86885 8.54092 4.14229 9.86484 4.14229C12.6187 4.14229 13.125 5.95576 13.125 8.31123V13.1247H13.1221Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.125,
    height: 15,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedIn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LinkedIn.05415141.svg";
export { ForwardRef as ReactComponent };